module.exports = {
    GOOGLE_KEY:"AIzaSyD1AFWPoJqPaemwGO4A7P7Q6CsUJ1TLGJk" 

}